import { clients } from 'lib/https';
import { ConfigurationSettings } from 'models/configuration-settings';

/**
 * Notification Service
 * 
 * Handles API calls for fetching notifications from the notification feed
 */

export interface NotificationFeedRequest {
  page: number;
  pageSize: number;
  filter: any | null;
  sort: any | null;
  projectKey: string;
}

export interface NotificationItem {
  id: string;
  title: string;
  message: string;
  type: string;
  timestamp: string;
  read: boolean;
  [key: string]: any;
}

export interface NotificationFeedResponse {
  data: NotificationItem[];
  totalCount: number;
  unseenCount: number;
  page?: number;
  pageSize?: number;
  errors?: any;
  [key: string]: any;
}

export interface UpdateNotificationVisibilityRequest {
  itemIds?: string[];
  seen?: boolean;
  read?: boolean;
  MarkAllRead?: boolean;
}

export interface UpdateNotificationVisibilityResponse {
  isSuccess?: boolean;
  [key: string]: any;
}

/**
 * Fetches notifications from the notification feed
 * 
 * @param config - Configuration settings containing API paths and blocksKey
 * @param request - Request parameters for pagination and filtering
 * @returns Promise with notification feed response
 */
export const getNotificationFeed = async (
  config: ConfigurationSettings,
  request: NotificationFeedRequest
): Promise<NotificationFeedResponse> => {
  console.log('config.paths.baseUrl', config.paths.baseUrl)
  const baseUrl = `https://${config.paths.baseUrl}`;
  const url = `${baseUrl}${config.paths.bebrave.notificationGets}`;
    
  return clients.post<NotificationFeedResponse>(
    url,
    config.blocksKey,
    JSON.stringify(request)
  );
  
};

/**
 * Updates the visibility status of notifications (marks them as seen)
 * 
 * @param config - Configuration settings containing API paths and blocksKey
 * @param request - Request containing itemIds and visibility status
 * @returns Promise with update response
 */
export const updateNotificationVisibility = async (
  config: ConfigurationSettings,
  request: UpdateNotificationVisibilityRequest
): Promise<UpdateNotificationVisibilityResponse> => {
  // eslint-disable-next-line no-console
  console.log('Updating notification visibility:', request);
  const baseUrl = `https://${config.paths.baseUrl}`;
  console.log('config.paths.bebrave.updateNotificationVisibility', config.paths.bebrave.notificationUpdateVisibility)
  const url = `${baseUrl}/${config.paths.bebrave.notificationUpdateVisibility}`;
    
  return clients.post<UpdateNotificationVisibilityResponse>(
    url,
    config.blocksKey,
    JSON.stringify(request)
  );
};
